import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToolsProvider } from '../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';

@Component({
  selector: 'service-card',
  templateUrl: 'service-card.html',
})
export class ServiceCardComponent {
  log = debug('app:ServiceCardComponent');
  block = false;
  @Input() service: any = {};
  @Output() openDetail = new EventEmitter<any>();
  @Output() getNextGooglePlaceData = new EventEmitter<any>();
  @Input() initGooglePlaceDetails = false;
  serviceTags = [];
  loaded = false;

  constructor(private toolsService: ToolsProvider) {}

  ngOnInit() {
    if (this.initGooglePlaceDetails) {
      this.getPlaceDetails();
    }
    if (this.service.placeType === 'LEGAL_SERVICES') {
      this.serviceTags = _.chunk(
        this.toolsService.getServiceTags().filter(d => {
          return _.get(this.service, `info.legalTags.${d}`);
        }),
        2
      );
    } else if (this.service.placeType === 'FREIGHT_FACTORING') {
      this.serviceTags = _.chunk(
        this.toolsService.getServiceTags().filter(d => {
          return _.get(this.service, `info.freightTags.${d}`);
        }),
        2
      );
    } else if (this.service.placeType === 'OWN_AUTHORITY_SERVICES') {
      this.serviceTags = _.chunk(
        this.toolsService.getServiceTags().filter(d => {
          return _.get(this.service, `info.ownAuthorityTags.${d}`);
        }),
        2
      );
    } else {
      this.serviceTags = _.chunk(
        this.toolsService.getServiceTags().filter(d => {
          return _.get(this.service, `info.wreckerTags.${d}`);
        }),
        2
      );
    }

    this.loaded = true;
  }

  getPlaceDetails() {
    this.getNextGooglePlaceData.emit();
  }

  call() {
    this.block = true;
    const phone = _.get(this.service, 'phone');
    if (phone) {
      this.log('call service: ', phone);
      this.toolsService.callPhone(phone);
      this.logEvent(this.service, 'call');
    }
    setTimeout(() => {
      this.block = false;
    }, 500);
  }

  openSite() {
    this.block = true;

    this.logEvent(this.service, 'viewWebsite');

    this.toolsService.openExternalUrl(
      `https://${this.service.website}`,
      '_blank'
    );
  }

  goToDetailPage() {
    setTimeout(() => {
      if (this.block === false) {
        this.toolsService.logAnalyticsEvent('trackCustom', 'viewWrecker', {
          service: _.get(this.service, '_id'),
        });
        this.openDetail.emit(this.service);
      }
    }, 250);
  }

  logEvent(service, eventType: 'viewWebsite' | 'call') {
    const serviceLookup = {
      LEGAL_SERVICES: 'legal',
      WRECKER_SERVICES: 'wrecker',
      FREIGHT_FACTORING: 'freight',
      OWN_AUTHORITY_SERVICES: 'authority',
    };
    const serviceType = serviceLookup[_.get(service, 'placeType')] || 'service';

    this.toolsService.logAnalyticsEvent(
      'trackCustom',
      `${serviceType}-${eventType}`,
      {
        placeName: _.get(service, 'name', ''),
        placeId: _.get(service, '_id', ''),
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/service-card/service-card.ts